(function() {
  'use strict';
  
  angular
    .module('plugins.q-and-a')
    .factory(
      'qAndAResultExportCsv', 
      qAndAResultExportCsv
    );
      
  qAndAResultExportCsv.$inject = [
    '$log', 
    '$filter', 
    '$q', 
    'csvWriter'
  ];
    
  function qAndAResultExportCsv(
      $log, 
      $filter, 
      $q, 
      csvWriter) {
    $log = $log.getInstance('qAndAResultExportCsv');
    
    return {
      canExportResult: canExportResult,
      exportResults: exportResults
    };
    
    function canExportResult(result) {
      return result.type === 'q-and-a';
    }
    
    function exportResults(results) {
      $log.debug('results = ', results);
      var csv = csvWriter();
      var resultsByPoll = groupResultsByPoll(results);
      _.each(resultsByPoll, function(pollResults, pollId) {
        var group = _.first(pollResults).group;
        var poll = _.first(pollResults).poll;
        var responses = _.flatten(_.pluck(pollResults, 'responses'));
        addHeaderForPoll(csv, group, poll);
        addResponsesForPoll(csv, responses);
      });
      return $q.resolve(csv.blob());
    }
    
    function addHeaderForPoll(csv, group, poll) {
      csv
        .addRow(['Group:', group.name])
    }
    
    function addResponsesForPoll(csv, responses) {
      var questions = []
      csv.addRow(['First Name', 'Last Name', 'Username', 'Email', 'Timestamp', 'Question', 'Upvotes']);
      responses.forEach(function(response) {
        if (response.data.question) {
          questions.push(response);
        } else {
          _.each(questions, function(q) {
            if (q._id === response.data.upvote) {
              var index = q.data.upvotes.indexOf(response.user._id)
              if (index === -1) {
                q.data.upvotes.push(response.user._id);
              } else {
                q.data.upvotes.splice(index, 1)
              }
            }
          })
        }
      });
      questions.forEach(function(question){
        csv.addRow([
          question.user.name.first,
          question.user.name.last,
          question.user.username,
          question.user.email, 
          $filter('date')(question.time, 'yyyy-MM-dd HH:mm:ss'), 
          question.data.question,
          question.data.upvotes.length
        ]);
      })
      csv.newRow();
    }
    
    function groupResultsByPoll(results) {
      return _.groupBy(results, function(result) {
        return result.poll._id;
      });
    }
  }
  
})();
